import { IOHelper, JSONHelper, utils } from '@neo-one/client-common';
import { ContractParameterBase } from './ContractParameterBase';
import { ContractParameterType } from './ContractParameterType';
export class ByteArrayContractParameter extends ContractParameterBase {
    constructor(value) {
        super();
        this.type = ContractParameterType.ByteArray;
        this.value = value;
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfVarBytesLE(this.value));
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        super.deserializeContractParameterBaseWireBase(options);
        const value = reader.readVarBytesLE();
        return new this(value);
    }
    get size() {
        return this.sizeInternal();
    }
    asBuffer() {
        return this.value;
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeVarBytesLE(this.value);
    }
    serializeJSON(_context) {
        return {
            type: 'ByteArray',
            value: JSONHelper.writeBuffer(this.value),
        };
    }
}

//# sourceMappingURL=ByteArrayContractParameter.js.map
